/* ============================================================
   EVERING: 選択肢が1つしかないオプションの自動選択（solo-option）

   非表示化と情報表示は snippets/evering-solo-option.liquid の CSS 側で
   静的に完了している。このスクリプトの役割は1つだけ:

     既存の sp-product-variant-picker の color-item クリックハンドラに乗って
     「残りわずか」在庫チェックを発火させること。

   radio は Shopify が最初から checked にしているため、これが失敗しても
   バリアントは成立し、サイズ選択 → カート追加は既存ロジックのまま動く。
   （= 落ちても購入導線に影響しない安全な位置づけ）

   jQuery の $.trim 等バージョン差のあるAPIは使わず、ネイティブclickのみ使う。
   ============================================================ */
(function () {
  'use strict';

  var MAX_WAIT = 30; // 100ms x 30 = 最大3秒 jQuery とハンドラの準備を待つ
  var waited = 0;

  function only(selector) {
    var nodes = document.querySelectorAll(selector);
    return nodes.length === 1 ? nodes[0] : null;
  }

  function fire() {
    // 既存の click ハンドラは jQuery で登録されるため、jQuery の準備を待つ
    if (!window.jQuery) {
      if (waited++ < MAX_WAIT) setTimeout(fire, 100);
      return;
    }

    try {
      // 選択肢が1つしかないときだけ自動クリック（複数あるなら通常商品なので触らない）
      var plan = only('#planSection .plan-item');
      var color = only('#colorSection .color-item');

      if (plan) plan.click();
      if (color) color.click();
    } catch (e) {
      // 在庫チェックの発火に失敗しても購入はできるため、ここでは何もしない
    }
  }

  function boot() {
    // 既存スクリプトが DOMContentLoaded 後に radio の初期化を行うため、その後に発火させる
    setTimeout(fire, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
